var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronLeft = function SvgChevronLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.235.235a.815.815 0 0 0-1.145 0L.716 5.549a.632.632 0 0 0 0 .902l5.374 5.314a.815.815 0 0 0 1.145 0 .793.793 0 0 0 0-1.132L2.552 5.997l4.69-4.636A.79.79 0 0 0 7.235.235Z",
    fill: "#141414"
  })));
};
export default SvgChevronLeft;